import React, { useState } from 'react';
// import { Button } from './Button';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  return (
    <>
      <nav className='navbar'>
        <div className='navbar-container'>
          <div className='menu-icon' onClick={handleClick}>
            <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>
            <li className='nav-item'>
              <Link to='/' className='nav-links' onClick={closeMobileMenu}>
                Home
              </Link>           
            </li>
            <li className='nav-item'>
              <a
                target="_parent"
                href='https://experience.arcgis.com/experience/ae1bfe36c4d7480c876e24475c34d6e4'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Mural Map
              </a>
            </li>
            <li className='nav-item'>
              <Link
                to='/survey'
                className='nav-links'
                onClick={closeMobileMenu}
              >
                Mural Submission
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
